import { useMiniSite } from "../../components/minisite/context";
import {
  ContactCard, PickupCard, InquirySection, BusinessLocationSection,
} from "../RentalProfile";

export default function MiniSiteContact() {
  const { data, theme } = useMiniSite();
  const ms = data.mini_site || {};

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 overflow-x-hidden" data-testid="ms-contact-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        Contact
      </h1>
      <p className="text-sm text-slate-600 mt-1 max-w-2xl">
        Reach the business directly, or send a quick inquiry through ConfirmPH.
      </p>

      <div className="mt-6 grid lg:grid-cols-3 gap-4">
        <div className="min-w-0"><ContactCard contact={data.contact} /></div>
        <div className="min-w-0"><PickupCard locations={data.public_pickup_locations} /></div>
        <div className="rounded-xl border border-slate-200 bg-white p-5 min-w-0">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Pickup & delivery</div>
          <p className="mt-2 text-sm text-slate-700 whitespace-pre-line">
            {ms.pickup_delivery_notes
              || "Pickup or handover is arranged after the booking is confirmed, subject to the applicable payment, agreement, vehicle and driver requirements."}
          </p>
        </div>
      </div>

      {data.business_location && (data.business_location.has_coordinates || data.business_location.city || data.business_location.label) && (
        <div className="mt-2">
          <BusinessLocationSection location={data.business_location} />
        </div>
      )}

      <div className="mt-6">
        <InquirySection id={data.id} businessName={data.name} onClose={() => {}} />
      </div>
    </div>
  );
}
